export const SET_RESOURCES_IN_HOUR = 'SET_RESOURCES_IN_HOUR';
export const SET_LEVELS_IN_PLACE_BY_ENTITITES = 'SET_LEVELS_IN_PLACE_BY_ENTITITES';
export const SET_RES_IN_PLACE_BY_HOURS = 'SET_RES_IN_PLACE_BY_HOURS';